var _line, _line2, _line3, _line4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSdsIconGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "normal",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 19.47,
    y1: 9.04,
    x2: 19.47,
    y2: 54.96,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 44.53,
    y1: 9.04,
    x2: 44.53,
    y2: 54.96,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 9.04,
    y1: 19.47,
    x2: 54.96,
    y2: 19.47,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "wasm-icon-stroke",
    x1: 9.04,
    y1: 44.53,
    x2: 54.96,
    y2: 44.53,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "4.79px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdsIconGrid);
export default __webpack_public_path__ + "static/media/SDS_icon_Grid.3649918738333bda150c14d33a94e30f.svg";
export { ForwardRef as ReactComponent };